// new Aleksei
import { useQuery } from '@tanstack/react-query';
import supabase from 'sdk/api';

const getProductsByStore = async (storeId: string) => {
    const { data, error } = await supabase
        .from('products')
        .select('*')
        .eq('store_id', storeId)
        .not('store_id', 'is', null)
        .order('created_at', { ascending: false });

    if (error) {
        throw new Error(error.message);
    }

    return data;
};

const useGetProductsByStore = (storeId: string) => {
    return useQuery({
        queryKey: ['products', 'store', storeId],
        queryFn: () => getProductsByStore(storeId),
        enabled: !!storeId,
    });
};

export default useGetProductsByStore;